<template>
  <div style="min-height:50rem;" id="wheight">
    <div id="mHeight">
      <div class="consultTop" id="consultpage1">
        <div class="consultTop1">
          <div class="consultTop1l">
            <div><span class="consultTop1ltxt">开闭馆时间</span></div>
            <div style="display: flex;margin-left: -0.125rem;">
              <div style="flex: 1;">
                <div class="consultTime">{{ contentInfo.openCloseTime }}</div>
                <div class="consultTime1">[{{ contentInfo.wicketHint }}]</div>
              </div>
              <div style="flex: 1;">
                <div class="consultTime">{{ contentInfo.closedWeek }}</div>
                <div class="consultTime1">[{{ contentInfo.holidaysHint }}]</div>
              </div>
            </div>
            <div class="consultTxt2">{{ contentInfo.address }}</div>
            <div><span class="consultTop1ltxt">交通路线</span></div>
            <div class="consultTxt3">
              乘坐34路、60路、K301路、K606路、K8 路至滨海街中段站，步行100m;<br>
              乘坐61路、K607路至图书馆站，步行260m;<br>
              乘坐1路、8路、14路、30路、44路、K1路、K508路、K7路至府西路站，步行350m。
            </div>
          </div>
          <div class="consultTop1r">

            <div class="consultright">参观须知</div>
            <div class="consultrTxt" v-html="contentInfo.admissionMode" style="white-space: pre-wrap;">
              <!-- 一、实行线上实名制分时段预约，现场须凭身份证原件扫码入馆，预约时间：1月11日-22日。<br>
              二、每场次限额200人／场（含陪同人员）<br>
              三、入馆须出示“健康码”及“行程码”绿码，请全程佩戴口罩，配合测量体温，“黄码”、“红码”及体温≥37.3°观众谢绝入馆。<br>
              四、试运营期间，暂不接受现场预约及团队预约。 -->
            </div>
            <!-- <div class="selfAppoint" style="margin-bottom: 0.2rem;" @click="toAppoint(1)">个人预约</div>
            <div class="selfAppoint selfAppoint1" @click="toAppoint(2)">团队预约</div> -->
          </div>
        </div>
      </div>
      <div style="width: 18rem;margin:0 auto;box-sizing: border-box;" id="consultpage2">
        <!-- <div class="wjdcSty">问卷调查</div>
        <img src="./image/wjdc.png" class="wjdcImg" style="cursor: pointer;" @click="toQuestion" /> -->
        <div class="wjdcSty" id="consultpage3">参观须知</div>
        <div class="wjdcTxt">
          <div class="teamContent" v-html="'一、' + dataInfo.openContent" style="white-space: pre-wrap;"></div>
          <div class="teamContent" v-html="'二、' + dataInfo.appointmentContent" style="white-space: pre-wrap;"></div>
          <div class="teamContent" v-html="'三、' + dataInfo.content" style="white-space: pre-wrap;"></div>
        </div>
        <div class="wjdcSty">推荐路线</div>
      </div>
      <div style="position: relative;width: 100%;height: 13.225rem;">
        <img src="./image/tjlx.png" style="position:absolute;top:0;left:0;width: 100%;height: 13.225rem;" />
        <div style="cursor:pointer;position:absolute;bottom: 1.625rem;left: 5.45rem;text-align:center;font-size: 0.25rem;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;
line-height: 0.5rem;width: 1.4625rem;height: 0.5rem;background: #EE564F;border-radius: 0.0625rem;">
          <div class="consultxcd">
            <el-button @click="toPerson">行程单</el-button>
          </div>
        </div>
      </div>

      <div style="width: 18rem;margin:0 auto;box-sizing: border-box;" id="consultpage4">
        <div class="wjdcSty">服务设施</div>
        <div style="margin-bottom: 1.2125rem;">
          <div style="width: 100%;height:100%;position:relative">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in listData" :key="index">
                  <div><img v-lazy="item.img" style="width: 100%;height:auto" @click="swiperShow(item)"></div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <!-- <div style="display: flex;justify-content: space-between;" id="consultpage5">
          <div class="wjdcSty" style="flex: 1;">留言板</div>
          <div style="flex: 0 0 1.4625rem;display:flex;" class="wjdcSty" @click="toWrite" v-if="wShow == 1">
            <el-button>
              <span style="display: flex;align-items: center;">
                <img src="./image/tjly.png"
                  style="width: 0.325rem;height: 0.275rem;margin-right: 0.05rem;margin-top: 0.05rem;" />写留言
              </span>
            </el-button>
          </div>
          <div style="display: flex;align-items: center;justify-content: center;text-align:center;font-size: 0.25rem;font-family: Microsoft YaHei;font-weight: bold;color: #FFFFFF;;width: 1.4625rem;height: 0.5rem;line-height: 0.5rem;background: #EE564F;border-radius: 0.0625rem;">
            <img src="./image/tjly.png" style="width: 0.325rem;height: 0.275rem;margin-top: 0.05rem;margin-right: 0.05rem;"/>写留言
          </div>
        </div> -->
        <!-- <div class="consultly" style="box-sizing: border-box;">
          <div class="consultwrite" v-if="wShow == 2">
            <el-input type="textarea" v-model="content" placeholder="请输入建议内容" resize="none" maxlength="200"
              show-word-limit></el-input>
          </div>
          <div class="wjdcSty wjdcSty1" @click="toSubmit" v-if="wShow == 2">
            <el-button :disabled="content ? false : true" :style="content ? '' : 'opacity:0.3'">
              <span style="display: flex;align-items: center;">
                <img src="./image/tjly.png"
                  style="width: 0.325rem;height: 0.275rem;margin-right: 0.05rem;margin-top: 0.05rem;" />提交留言
              </span>
            </el-button>
          </div>
          <div style="clear: both;"></div>
          <div v-if="lyList.length > 0">
            <div class="consultly1" v-for="(item, index) in lyList" :key="index">
              <div class="consultly2">
                <img v-lazy="item.image" class="consultly3" style="border-radius: 50%;" />
                <div class="consultly4">
                  <div class="consultly5">{{ item.createUserName }}</div>
                  <div class="consultly6">{{ item.message }}</div>
                </div>
                <div class="consultly7">{{ item.createTime }}</div>
              </div>
              <div class="consultly8" v-if="item.reply">
                <div class="consultly9">
                  <img class="consultly10" src="./image/tx.png" style="border-radius: 50%;" />
                  <div class="consultly11">
                    <div class="consultly12">泉州科技馆</div>
                    <div class="consultly13">回复：{{ item.reply }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else
            style="width: 100%;padding-top: 0.5rem;padding-bottom:0.5rem;text-align: center;font-size: 0.325rem;">暂无数据
          </div>
        </div> -->
        <div class="contact-pagination" style="margin-top: 1.0875rem;margin-bottom: 1.0875rem;">
          <el-pagination v-if="total > 0" background page-size="10" :current-page.sync="page"
            @current-change="handleCurrentChange" :hide-on-single-page="value" layout="prev, pager, next" :total="total"
            style="text-align: center;">
          </el-pagination>
        </div>
        <el-dialog class="selfDiag2" title="" :visible.sync="diag7" center>
          <div id="imageMap7" style="width: 100%;height: 532px;"></div>
        </el-dialog>
        <el-dialog class="selfDiag2" title="" :visible.sync="diag1" center>
          <div id="imageMap1" style="width: 100%;height: 532px;"></div>
        </el-dialog>
        <el-dialog class="selfDiag2" title="" :visible.sync="diag2" center>
          <div id="imageMap2" style="width: 100%;height: 532px;"></div>
        </el-dialog>
        <el-dialog class="selfDiag2" title="" :visible.sync="diag3" center>
          <div id="imageMap3" style="width: 100%;height: 532px;"></div>
        </el-dialog>
        <el-dialog class="selfDiag2" title="" :visible.sync="diag4" center>
          <div id="imageMap4" style="width: 100%;height: 532px;"></div>
        </el-dialog>
        <el-dialog class="selfDiag2" title="" :visible.sync="diag5" center>
          <div id="imageMap5" style="width: 100%;height: 532px;"></div>
        </el-dialog>
        <!--        <div style="display: flex;width: 100%;height: 10.75rem;margin-bottom: 0.9rem;background: #fff;align-items: center;padding:0 0.575rem;box-sizing: border-box;">
          <div style="flex: 0 0 4.3125rem;height: 3.725rem;">
            <img src="./image/email.png" style="width:4.3125rem;height: 3.725rem;"/>
          </div>
          <div style="flex: 1;padding-left: 1.875rem;box-sizing: border-box;">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <div class="selfBut">
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="移动电话" prop="tel">
                    <el-input v-model="ruleForm.card" placeholder="请输入移动电话"></el-input>
                  </el-form-item>
                  <el-form-item label="电子邮箱" prop="email">
                    <el-input v-model="ruleForm.tel" placeholder="请输入电子邮箱"></el-input>
                  </el-form-item>
                  <el-form-item label="建议内容" prop="suggest" style="min-height: 2.6875rem">
                    <el-input type="textarea" v-model="ruleForm.tel" placeholder="请输入建议内容"></el-input>
                  </el-form-item>
                  <el-form-item style="text-align: left;height: auto;" class="tjSty">
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitStep">提交</el-button>
                  </el-form-item>
              </div>
            </el-form>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { getMe } from '@/api/login.js'
//内容管理类型
import { getInfo } from '@/api/index/index.js'
import { getAppointmentNotice } from '@/api/selfAppoint/index.js'
//留言板
import { getRemarkList, getSave } from '@/api/consult/index.js'
import Swiper from "swiper";
import 'swiper/css/swiper.css';

import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/leaflet'
import 'leaflet/dist/leaflet-src'
import 'leaflet/dist/leaflet-src.esm'
import * as L from 'leaflet'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
})
L.Marker.prototype.options.icon = DefaultIcon
export default {
  name: 'home',
  data() {
    return {
      value: false,
      total: 0,
      page: '1',
      limit: '10',
      iconImg: require('./image/marker.png'),
      diag7: false,
      diag1: false,
      diag2: false,
      diag3: false,
      diag4: false,
      diag5: false,
      wShow: 1,
      content: '',
      ruleForm: {
        name: '',
        tel: '',
        email: '',
        suggest: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        tel: [
          { required: true, message: '请输入移动电话', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
        ],
        suggest: [
          { required: true, message: '请输入建议内容', trigger: 'blur' },
        ],
      },
      lyList: [
      ],
      // total:12,
      page: 1,
      contentInfo: {},
      dataInfo: {},
      listData: [
        { id: 1, img: require('./image/b1.png') },
        { id: 2, img: require('./image/1f.png') },
        { id: 3, img: require('./image/2f.png') },
        { id: 4, img: require('./image/3f.png') },
        { id: 5, img: require('./image/4f.png') },
        { id: 6, img: require('./image/5f.png') },
      ],
      hdState: [
        { id: 1, name: '最新活动', show: true },
        { id: 2, name: '专题活动', show: false },
        { id: 3, name: '活动回顾', show: false },
        { id: 1, name: '最新活动', show: true },
        { id: 2, name: '专题活动', show: false },
        { id: 3, name: '活动回顾', show: false },

      ],
      itemList: [
        {
          id: 1, img: require('./image/consult.png'), title: '东海科普大讲堂 带你走近飞羽精灵 爱鸟护鸟你我共参与', time: '2022-06-12 —— 2022-06-12',
          address: '活动地点：泉州市科技馆学术报告厅', people: '6岁以上', limit: '100'
        }
      ],
      timer: null
    }
  },
  destroyed() {
    window.clearInterval(this.timer)
  },
  created() {
    this.getRemarkList()
    //参观须知
    this.getAppointmentNotice()
    //
    //内容管理
    this.getInfo()
  },
  mounted() {
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 3,
      slidesPerColumn: 1,
      spaceBetween: 100,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  },
  components: {},
  computed: {

  },
  watch: {
    "$route.query.id": {
      immediate: true,
      handler(val, old) {
        this.$nextTick(() => {
          var _this = this
          var timer = setInterval(function () {
            // 判断文档和所有子资源(图片、音视频等)已完成加载
            if (document.readyState === 'complete') {
              //执行方法
              if (val == 1) {
                document.getElementById('consultpage1').scrollIntoView(true)
              } else if (val == 2) {
                document.getElementById('consultpage2').scrollIntoView(true)
              } else if (val == 3) {
                document.getElementById('consultpage3').scrollIntoView(true)
              } else if (val == 4) {
                document.getElementById('consultpage4').scrollIntoView(true)
              } else if (val == 5) {
                document.getElementById('consultpage5').scrollIntoView(true)
              } else {
                window.scrollTo(0, 0)
              }
              window.clearInterval(timer)
            }
          }, 50)
          this.timer = timer
        })
      }
    },
    // "$route.query.time":{
    //   immediate:true,
    //   handler(val,old){
    //     this.$nextTick(()=>{
    //       var _this = this
    //       var timer = setInterval(function () {
    //           // 判断文档和所有子资源(图片、音视频等)已完成加载
    //           if (document.readyState === 'complete') {
    //               //执行方法
    //              if(_this.$route.query.id==1){
    //                  document.getElementById('consultpage1').scrollIntoView(true)
    //              }else if(_this.$route.query.id==2){
    //                  document.getElementById('consultpage2').scrollIntoView(true)
    //              }else if(_this.$route.query.id==3){
    //                  document.getElementById('consultpage3').scrollIntoView(true)
    //              }else if(_this.$route.query.id==4){
    //                  document.getElementById('consultpage4').scrollIntoView(true)
    //              }else if(_this.$route.query.id==5){
    //                  document.getElementById('consultpage5').scrollIntoView(true)
    //              }else{
    //                window.scrollTo(0,0)
    //              }
    //               window.clearInterval(timer)
    //           }
    //       }, 50)

    //     })
    //   }
    // }
  },
  methods: {
    initDate5() {
      var map = L.map('imageMap5', {
        zoomControl: false,
        attributionControl: false,
        minZoom: 1,
        maxZoom: 5,
        center: [0, 0],
        dragging: true,
        zoom: 4,
        doubleClickZoom: false,
        closePopupOnClick: false,
        scrollWheelZoom: true,
        crs: L.CRS.Simple // 这表明leaflet使用1：1映射，在屏幕像素和经纬度坐标系统之间。换句话说，我们的图片是平的，不是全球的，我们在投影一张平面图片。
      })
      // 定义了图片尺寸和它的路径，路径可以引用网络链接
      var w = 1200
      var h = 576
      var url = require('./image/5ft.png')
      // 把图片通过地图的方式放出来，所以需要一个像素坐标到经纬度坐标（系统）的转换。 把西南，东北角的像素坐标逆映射为经纬度坐标网。
      var southWest = map.unproject([0, h], map.getMaxZoom() - 1)
      var northEast = map.unproject([w, 0], map.getMaxZoom() - 1)
      var bounds = new L.LatLngBounds(southWest, northEast)
      L.imageOverlay(url, bounds).addTo(map)
      L.marker([-8, 12], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-12, 4], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-11, 9.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-10, 17], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-6, 25], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-5.5, 33], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-3.5, 45], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-4.8, 54], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-17.5, 67], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-18, 66], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-20, 24], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>扶梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-27, 25.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-28.8, 26], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-32, 28], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      map.setMaxBounds(bounds)
    },
    initDate4() {
      var map = L.map('imageMap4', {
        zoomControl: false,
        attributionControl: false,
        minZoom: 1,
        maxZoom: 5,
        center: [0, 0],
        dragging: true,
        zoom: 4,
        doubleClickZoom: false,
        closePopupOnClick: false,
        scrollWheelZoom: true,
        crs: L.CRS.Simple // 这表明leaflet使用1：1映射，在屏幕像素和经纬度坐标系统之间。换句话说，我们的图片是平的，不是全球的，我们在投影一张平面图片。
      })
      // 定义了图片尺寸和它的路径，路径可以引用网络链接
      var w = 1200
      var h = 576
      var url = require('./image/4ft.png')
      // 把图片通过地图的方式放出来，所以需要一个像素坐标到经纬度坐标（系统）的转换。 把西南，东北角的像素坐标逆映射为经纬度坐标网。
      var southWest = map.unproject([0, h], map.getMaxZoom() - 1)
      var northEast = map.unproject([w, 0], map.getMaxZoom() - 1)
      var bounds = new L.LatLngBounds(southWest, northEast)
      L.imageOverlay(url, bounds).addTo(map)
      L.marker([-8, 12], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-10.5, 17], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-11, 9.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      // L.marker([-14.5,13],{
      //    icon: new L.divIcon({
      //       className: "lmap-icon2",
      //       html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src="+this.iconImg +" style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
      //       // iconAnchor: [16, 16],
      //       // iconSize: [134,40],
      //     })
      // })
      //   .addTo(map)

      L.marker([-7, 25], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-6.5, 30], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-5, 43], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-4.8, 49], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-18, 65], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-19.5, 64], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-20, 24], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>扶梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-26, 25.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-29, 25], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-30.5, 28], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      map.setMaxBounds(bounds)
    },
    initDate3() {
      var map = L.map('imageMap3', {
        zoomControl: false,
        attributionControl: false,
        minZoom: 1,
        maxZoom: 5,
        center: [0, 0],
        dragging: true,
        zoom: 4,
        doubleClickZoom: false,
        closePopupOnClick: false,
        scrollWheelZoom: true,
        crs: L.CRS.Simple // 这表明leaflet使用1：1映射，在屏幕像素和经纬度坐标系统之间。换句话说，我们的图片是平的，不是全球的，我们在投影一张平面图片。
      })
      // 定义了图片尺寸和它的路径，路径可以引用网络链接
      var w = 1200
      var h = 576
      var url = require('./image/3ft.png')
      // 把图片通过地图的方式放出来，所以需要一个像素坐标到经纬度坐标（系统）的转换。 把西南，东北角的像素坐标逆映射为经纬度坐标网。
      var southWest = map.unproject([0, h], map.getMaxZoom() - 1)
      var northEast = map.unproject([w, 0], map.getMaxZoom() - 1)
      var bounds = new L.LatLngBounds(southWest, northEast)
      L.imageOverlay(url, bounds).addTo(map)
      L.marker([-8, 12], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-12, 4], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-11, 9.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-14.5, 13], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-7, 25], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-6.5, 30], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-5, 43], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-4.8, 49], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-18, 65], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-19.5, 64], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-20, 24], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>扶梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-26, 25.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-29, 25], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-32, 28], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      map.setMaxBounds(bounds)
    },
    initDate1() {
      var map = L.map('imageMap1', {
        zoomControl: false,
        attributionControl: false,
        minZoom: 1,
        maxZoom: 5,
        center: [0, 0],
        dragging: true,
        zoom: 4,
        doubleClickZoom: false,
        closePopupOnClick: false,
        scrollWheelZoom: true,
        crs: L.CRS.Simple // 这表明leaflet使用1：1映射，在屏幕像素和经纬度坐标系统之间。换句话说，我们的图片是平的，不是全球的，我们在投影一张平面图片。
      })
      // 定义了图片尺寸和它的路径，路径可以引用网络链接
      var w = 1200
      var h = 576
      var url = require('./image/1ft.png')
      // 把图片通过地图的方式放出来，所以需要一个像素坐标到经纬度坐标（系统）的转换。 把西南，东北角的像素坐标逆映射为经纬度坐标网。
      var southWest = map.unproject([0, h], map.getMaxZoom() - 1)
      var northEast = map.unproject([w, 0], map.getMaxZoom() - 1)
      var bounds = new L.LatLngBounds(southWest, northEast)
      L.imageOverlay(url, bounds).addTo(map)
      L.marker([-11, 5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-14, 11], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-12, 14.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-8, 26], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-6, 45], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)


      L.marker([-17.5, 67], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-20.5, 69], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-23, 61], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-21.5, 55], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>文创室</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-25, 47], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>服务台</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-21.5, 25], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>扶梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-27, 24], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>母婴室</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-27, 28], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>医务室</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-28, 30], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      map.setMaxBounds(bounds)
    },
    initDate7() {
      var map = L.map('imageMap7', {
        zoomControl: false,
        attributionControl: false,
        minZoom: 1,
        maxZoom: 5,
        center: [0, 0],
        dragging: true,
        zoom: 4,
        doubleClickZoom: false,
        closePopupOnClick: false,
        scrollWheelZoom: true,
        crs: L.CRS.Simple // 这表明leaflet使用1：1映射，在屏幕像素和经纬度坐标系统之间。换句话说，我们的图片是平的，不是全球的，我们在投影一张平面图片。
      })
      // 定义了图片尺寸和它的路径，路径可以引用网络链接
      var w = 1200
      var h = 576
      var url = require('./image/b1ft.png')
      // 把图片通过地图的方式放出来，所以需要一个像素坐标到经纬度坐标（系统）的转换。 把西南，东北角的像素坐标逆映射为经纬度坐标网。
      var southWest = map.unproject([0, h], map.getMaxZoom() - 1)
      var northEast = map.unproject([w, 0], map.getMaxZoom() - 1)
      var bounds = new L.LatLngBounds(southWest, northEast)
      L.imageOverlay(url, bounds).addTo(map)
      L.marker([-23, 27], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-17, 29], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>扶梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-15, 36], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>5d影院</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-8, 60], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>球幕影院</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-11, 69], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      map.setMaxBounds(bounds)
    },
    initDate2() {
      var map = L.map('imageMap2', {
        zoomControl: false,
        attributionControl: false,
        minZoom: 1,
        maxZoom: 5,
        center: [0, 0],
        dragging: true,
        zoom: 4,
        doubleClickZoom: false,
        closePopupOnClick: false,
        scrollWheelZoom: true,
        crs: L.CRS.Simple // 这表明leaflet使用1：1映射，在屏幕像素和经纬度坐标系统之间。换句话说，我们的图片是平的，不是全球的，我们在投影一张平面图片。
      })
      // 定义了图片尺寸和它的路径，路径可以引用网络链接
      var w = 1200
      var h = 576
      var url = require('./image/2ft.png')
      // 把图片通过地图的方式放出来，所以需要一个像素坐标到经纬度坐标（系统）的转换。 把西南，东北角的像素坐标逆映射为经纬度坐标网。
      var southWest = map.unproject([0, h], map.getMaxZoom() - 1)
      var northEast = map.unproject([w, 0], map.getMaxZoom() - 1)
      var bounds = new L.LatLngBounds(southWest, northEast)
      L.imageOverlay(url, bounds).addTo(map)
      L.marker([-13, 3.5], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-12, 6], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-8.7, 13], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-15, 15], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-11, 17], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>卫生间</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-6.5, 55], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-7.5, 26], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-7, 32], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-5, 47], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-20.5, 70], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-18, 68], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)


      L.marker([-21, 25], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>扶梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      L.marker([-27, 26], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>电梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)
      L.marker([-30, 29], {
        icon: new L.divIcon({
          className: "lmap-icon2c",
          html: "<div style='position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%);'><div class='icon-container'><img src=" + this.iconImg + " style='width: 32px;'> </div><div class='title-con'><span>楼梯</span></div></div>",
          // iconAnchor: [16, 16],
          // iconSize: [134,40],
        })
      })
        .addTo(map)

      map.setMaxBounds(bounds)
    },
    //内容管理
    getInfo() {
      getInfo().then(res => {
        if (res.data.code == 0) {
          this.contentInfo = res.data.contenfronpageManage
        } else {
          // this.$message({
          //   message: res.data.msg,
          //   type: 'warning'
          // });
        }

      })
    },
    getAppointmentNotice() {
      getAppointmentNotice().then(res => {
        if (res.data.code == 0) {
          this.dataInfo = res.data.data
          this.$nextTick(() => {
            let height = document.getElementById('mHeight').offsetHeight + 50 + 'px'
            document.getElementById('wheight').style = "min-height:" + height
          })
        }
      })
    },
    getSave() {
      getSave({ message: this.content }).then(res => {
        if (res.data.code == 0) {
          this.$message.success('留言成功')
          this.wShow = 1
          this.getRemarkList()
        } else if (res.data.code == '403') {
          this.$message.success('请先登录再操作')
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000)
        }
      })
    },
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();

      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      if (hours < 0) hours = '0' + hours;
      if (min < 10) min = '0' + min;
      if (seconds < 10) seconds = '0' + seconds;

      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
    },
    handleCurrentChange(val) {
      this.page = val
      this.getRemarkList()
    },
    getRemarkList() {
      getRemarkList({ params: 1, page: this.page, limit: this.limit }).then(res => {
        if (res.data.code == 0) {
          let lyList = res.data.page.list
          lyList.forEach(item => {
            item.createTime = this.timeFormatSeconds(item.createTime)
          })
          this.lyList = lyList
          this.total = res.data.page.totalCount
          this.$nextTick(() => {
            let height = document.getElementById('mHeight').offsetHeight + 50 + 'px'
            document.getElementById('wheight').style = "min-height:" + height
          })
        }
      })
    },
    toPerson() {
      if (Cookies.get('userInfo')) {
        if (!JSON.parse(Cookies.get('userInfo')).token) {
          this.$message.success('请先登录再操作')
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000)
        } else {
          // getMe().then(res=>{
          //   if(res.data.code=='0'){
          this.$router.push({ name: 'PersonInfo', query: { cateId: 3, id: 0 } })
          //   }else if(res.data.code=='403'){
          //     Cookies.remove('userInfo')
          //     Cookies.remove('userAllInfo')
          //     this.$message.success('请先登录再操作')
          //     setTimeout(()=>{
          //       this.$router.push('/login')
          //     },1000)
          //   }else{
          //     this.zhShow=1
          //     Cookies.remove('userInfo')
          //     Cookies.remove('userAllInfo')
          //     this.$message.success('请先登录再操作')
          //     setTimeout(()=>{
          //       this.$router.push('/login')
          //     },1000)
          //   }
          // })
        }
      } else {
        this.$message.success('请先登录再操作')
        setTimeout(() => {
          this.$router.push('/login')
        }, 1000)
      }
    },
    toWrite() {
      this.content = ''
      this.wShow = 2
    },
    toSubmit() {
      if (this.content) {
        this.getSave()
      }
    },
    toAppoint(id) {
      if (Cookies.get('userInfo')) {
        if (!JSON.parse(Cookies.get('userInfo')).token) {
          this.$message.success('请先登录再操作')
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000)
        } else {
          // getMe().then(res=>{
          //   if(res.data.code=='0'){
          if (id == 1) {
            this.$router.push({ name: 'Self' })
          } else if (id == 2) {
            this.$router.push({ name: 'Team' })
          }
          //   }else if(res.data.code=='403'){
          //     Cookies.remove('userInfo')
          //     Cookies.remove('userAllInfo')
          //     this.$message.success('请先登录再操作')
          //     setTimeout(()=>{
          //       this.$router.push('/login')
          //     },1000)
          //   }else{
          //     this.zhShow=1
          //     Cookies.remove('userInfo')
          //     Cookies.remove('userAllInfo')
          //     this.$message.success('请先登录再操作')
          //     setTimeout(()=>{
          //       this.$router.push('/login')
          //     },1000)
          //   }
          // })
        }
      } else {
        this.$message.success('请先登录再操作')
        setTimeout(() => {
          this.$router.push('/login')
        }, 1000)
      }
    },
    toQuestion() {
      this.$router.push({ name: 'ConsultQuestion' })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.personList.length == 0) {
            this.$message.error('随行人员信息不可为空')
          } else {
            this.centerDialogVisible = true
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.show = 1
      this.$refs[formName].resetFields();
    },
    swiperShow(item) {
      if (item.id == 1) {
        this.diag7 = true
        setTimeout(() => {
          this.initDate7()
        }, 10)
      } else if (item.id == 2) {
        this.diag1 = true
        setTimeout(() => {
          this.initDate1()
        }, 10)
      } else if (item.id == 3) {
        this.diag2 = true
        setTimeout(() => {
          this.initDate2()
        }, 10)
      } else if (item.id == 4) {
        this.diag3 = true
        setTimeout(() => {
          this.initDate3()
        }, 10)
      } else if (item.id == 5) {
        this.diag4 = true
        setTimeout(() => {
          this.initDate4()
        }, 10)
      } else if (item.id == 6) {
        this.diag5 = true
        setTimeout(() => {
          this.initDate5()
        }, 10)
      }
    },
    toClick(item) {
      item.show = !item.show
    }
  },
}
</script>
<style>
.icon-container {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -90%);
  transform: translate(-50%, -90%);
}

.title-con {
  position: absolute;
  top: 0;
  left: 50%;
  padding-bottom: 12px;
  -webkit-transform: translate(-50%, 10%);
  transform: translate(-50%, 10%);
  font-weight: 600;
  white-space: nowrap;
}

.lmap-icon2c {
  float: right;
  white-space: nowrap;
  font-size: 14px;
  color: #000;
  font-weight: bold;
  border-radius: 10px;
  text-align: center;
}

.lmap-icon1c {
  font-size: 20px;
  color: #fff;
  background: #6E71B0;
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
}

.happy-scroll-content {
  width: 100%;
  border-bottom: none !important;
  border-top: none !important;
}

*::-webkit-scrollbar {
  display: none;
}

* {
  scrollbar-width: none;
}

* {
  -ms-overflow-style: none;
}

.happy-scroll-strip--vertical .happy-scroll-bar {
  opacity: 1 !important;
}

.happy-scroll-strip--vertical {
  z-index: 7000;
  background: #fff
}

.happy-scroll-strip--vertical .happy-scroll-bar {
  background: #fff;
  box-shadow: 1px;
}

.happy-scroll-strip--horizontal .happy-scroll-bar {
  border-radius: 7px;
  background: #fff;
  height: 6px !important;
  width: 0;
  -webkit-transition: height 0.4s ease, width 0.6s ease;
  transition: height 0.4s ease, width 0.6s ease;
}

.happy-scroll {}

.happy-scroll-container {
  height: 100% !important;
}
</style>
<style lang="less" scoped>
.contact-pagination /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgba(238, 86, 79, 1)
}

.selfDiag2 /deep/ .el-dialog {
  min-width: 1300px !important;

  background: #FFFFFF;
  border-radius: 0.125rem;
}

.selfDiag2 /deep/ .el-dialog__title {
  font-size: 0.35rem;
  font-weight: bold;
  color: #333333;
}

.selfDiag2 /deep/ .el-dialog__header {
  padding-top: 0.5625rem;
}

.selfDiag2 .confirmBut.el-button {
  width: 2.5rem;
  height: 0.85rem;
  background: #EE564F;
  border-radius: 0.425rem;
  font-size: 0.3rem;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 0.85rem;
  padding: 0;
  border: none;
}

.selfDiag2 /deep/ .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 0.875rem;
  font-size: 0.35rem;
  color: #333333;
  padding-top: 0;
}

.selfDiag2 .confirmBut.el-button:active {
  box-shadow: inset 0px 0px 3px 3px #cf4a44;
}

.wjdcSty {
  font-size: 0.375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #222222;
  padding-top: 0.625rem;
  margin-bottom: 0.625rem;

  .el-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    font-size: 0.25rem;
    font-weight: bold;
    width: 1.4625rem;
    height: 0.5rem;
    line-height: 0.5rem;
    color: #FFFFFF;
    background: #EE564F;
    border: none;
  }

  .el-button:active {
    box-shadow: inset 0px 0px 2px 2px #cb5858;
  }
}

.wjdcSty1 {
  margin-top: 0.375rem;
  margin-bottom: 0.5rem;
  float: right;

  .el-button {
    width: 1.825rem;
  }
}

.consultxcd {
  .el-button {
    width: 1.4625rem;
    height: 0.5rem;
    background: #EE564F;
    border-radius: 0.0625rem;
    padding: 0;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    border: none;
    cursor: pointer;
  }

  .el-button:active {
    box-shadow: inset 0px 0px 1.5px 1.5px #cb5858;
  }
}

.eduContent8 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 3rem;

  .el-button {
    width: 1.75rem;
    height: 0.625rem;
    background: #F56C6C;
    border-radius: 0.05rem;
    padding: 0;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    border: none;
    cursor: pointer;
  }

}

.consultwrite {
  width: 100%;
  height: 2.5rem;
  background: #F5F8FC;
  border-radius: 0.0875rem;

  .el-textarea {
    height: 2.5rem;
    background: #F5F8FC;
  }

  /deep/ .el-textarea__inner {
    height: 2.5rem;
    background: #F5F8FC;
    padding: 0.2625rem;
    box-sizing: border-box;
    font-size: 0.275rem;
  }
}

#homePage {
  min-height: 100vh;
}

.consultTop {
  width: 100vw;
  padding: 1.2125rem 0;
  box-sizing: border-box;
  background-image: url(./image/consult.png);
  background-size: 100% 100%;
}

.consultTop1 {
  width: 18rem;
  margin: 0 auto;
  height: 100%;
  display: flex;
}

.consultTop1l {
  flex: 1;
}

.consultTop1r {
  flex: 0 0 4.5375rem;
  width: 4.5375rem;
  padding: 0 0 0.4375rem 0;
  // height: 6.825rem;
  background: #EE564F;
  border-radius: 0.05rem;
}

.consultTop1ltxt {
  font-size: 0.275rem;
  display: inline-block;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  position: relative;
}

.consultTop1ltxt:before {
  position: absolute;
  width: 0.05rem;
  height: 0.25rem;
  top: 50%;
  left: -0.1rem;
  transform: translate(-50%, -50%);
  content: '';
  background: red
}

.consultTime {
  font-size: 0.375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 0.375rem;
  margin-bottom: 0.225rem;
}

.consultTime1 {
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  margin-bottom: 0.5875rem;
}

.consultTxt2 {
  font-size: 0.375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  margin-bottom: 0.6125rem;
  margin-left: -0.125rem;
}

.consultTxt3 {
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: 0.375rem;
  line-height: 0.375rem;
}

.consultright {
  width: 1.875rem;
  height: 0.5rem;
  line-height: 0.5rem;
  background: #fff;
  margin: 0 auto;
  border-radius: 0 0 0.25rem 0.25rem;
  font-size: 0.25rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #EE564F;
  text-align: center;
}

.consultrTxt {
  font-size: 0.2rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 0.375rem;
  width: 100%;
  // height: 4.5rem;
  padding: 0.375rem;
  box-sizing: border-box;
}

.selfAppoint {
  width: 3.6875rem;
  height: 0.625rem;
  border: 1px solid #FFFFFF;
  border-radius: 0.3125rem;
  margin: 0 auto;
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 0.625rem;
  text-align: center;
  cursor: pointer;
}

.selfAppoint:hover {
  background-color: #fff;
  color: rgba(238, 86, 79, 1);
}

.selfAppoint1 {
  background-color: #fff;
  color: rgba(238, 86, 79, 1);
}

.wjdcImg {
  width: 100%;
  height: auto;
}

.wjdcTxt {
  width: 100%;
  padding: 0.5rem 0.525rem;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 0.05rem;
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  line-height: 0.475rem;
}

.swiper-pagination {
  width: 100%;
  text-align: center;
  margin-top: 0.375rem;
}

.swiper-pagination-clickable /deep/ .swiper-pagination-bullet {
  margin-right: 0.125rem;
}

/deep/ .swiper-pagination-bullet-active {
  background: rgba(238, 86, 79, 1) !important;
}

.consultly {
  padding: 0.3rem 0.5rem 0 0.5rem;
  margin-bottom: 0.625rem;
  width: 100%;
  background-color: #fff;
}

.consultly1 {
  padding: 0.5rem 0;
  border-bottom: 1px solid #E5E5E5;
}

.consultly2 {
  display: flex;
  width: 100%;
  align-items: center;
}

.consultly3 {
  flex: 0 0 0.875rem;
  width: 0.875rem;
  height: 0.875rem;
}

.consultly4 {
  flex: 1;
  padding-left: 0.35rem;
  width: 100%;
  box-sizing: border-box;
}

.consultly5 {
  font-size: 0.25rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #222222;
  line-height: 0.375rem;
}

.consultly6 {
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  line-height: 0.375rem;
}

.consultly7 {
  font-size: 0.2rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #222222;
}

.consultly8 {
  margin-top: 0.25rem;
  padding-left: 1.25rem;
  box-sizing: border-box;
}

.consultly9 {
  display: flex;
  width: 100%;
  padding: 0.1rem 0.375rem;
  box-sizing: border-box;
  background: #F8F8F8;
  min-height: 1.5rem;
  align-items: center;
}

.consultly10 {
  flex: 0 0 0.875rem;
  width: 0.875rem;
  height: 0.875rem;
}

.consultly11 {
  flex: 1;
  padding-left: 0.35rem;
  width: 100%;
  box-sizing: border-box;
}

.consultly12 {
  font-size: 0.25rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #222222;
  line-height: 0.375rem;
}

.consultly13 {
  font-size: 0.225rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  line-height: 0.375rem;
}

.consultly1:last-child {
  border-bottom: none;
}

.selfBut {}

.selfBut .el-button {
  width: 1.925rem;
  height: 0.6375rem;
  line-height: 0.6375rem;
  padding: 0;
  background: #EE564F;
  border-radius: 0.0875rem;
  font-size: 0.25rem;
  color: #FFFFFF;
}

.selfBut .el-form-item {
  height: 0.925rem;
  line-height: 0.925rem;
}

.selfBut /deep/ .el-form-item__label {
  height: 0.925rem;
  line-height: 0.925rem;
  text-align: right;
  font-size: 0.275rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
}

.selfBut /deep/ .el-input__inner {
  width: 7.875rem;
  height: 0.925rem;
  background: #F5F8FC;
  color: #000;
  // border: 1px solid #EE564F;
  border-radius: 0.0875rem;
}

.selfBut /deep/ .el-textarea__inner {
  min-height: 2.6875rem !important;
  width: 7.875rem;
  background: #F5F8FC;
  color: #000;
  border-radius: 0.0875rem;
}

.addSty .el-button {
  width: 1.25rem;
  height: 0.6375rem;
  background: #EE564F;
  border-radius: 0.0875rem;
  font-size: 0.25rem;
  color: #FFFFFF;
  line-height: 0.6375rem;
  padding: 0;
}

.prevStep.el-button {
  width: 3.75rem;
  height: 0.975rem;
  border: 0.0125rem solid #5C5DF6;
  border-radius: 0.05rem;
  font-size: 0.3rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #5C5DF6;
  line-height: 0.975rem;
  padding: 0;
  margin-top: 1.75rem;
}

.submitStep.el-button {
  width: 3.75rem;
  height: 0.975rem;
  padding: 0;
  line-height: 0.975rem;
  background: #5C5DF6;
  border-radius: 0.05rem;
  font-size: 0.3rem;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 0.5rem;
}

.tjSty .el-form-item__content {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/consult/consult.vue